import { Pipe, PipeTransform } from '@angular/core';

import { DateInput } from '@helpers/date.helper';

@Pipe({
  name: 'archived',
  standalone: true
})
export class ArchivedPipe implements PipeTransform {
  transform<T extends { archivedAt?: DateInput }>(values: T[], archived: boolean = true): T[] {
    return values.filter((value: T) => {
      const isArchived = !!value?.archivedAt;
      return archived ? isArchived : !isArchived;
    });
  }
}
